import { ADD_TO_CART,REMOVE_ITEM,SUB_QUANTITY,ADD_QUANTITY,UPDATE_ITEMS,CLEAR_CART} from './cart-actions'

//update products
export const updateItems= (items, categories)=>{
    return{
        type: UPDATE_ITEMS,
        items,
        categories
    }
}
//add cart action
export const addToCart= (id)=>{
    return{
        type: ADD_TO_CART,
        id
    }
}
//remove item action
export const removeItem=(id)=>{
    return{
        type: REMOVE_ITEM,
        id
    }
}
//subtract qt action
export const subtractQuantity=(id)=>{
    return{
        type: SUB_QUANTITY,
        id
    }
}
//add qt action
export const addQuantity=(id)=>{
    return{
        type: ADD_QUANTITY,
        id
    }
}
//clear cart action
export const clearCart=()=>{
    return{
        type: CLEAR_CART
    }
}
